import React, { useEffect } from "react";
import Marquee from "react-fast-marquee";
import aboutBg from "../../images/bg/about-bg.png";

// Animated GIFs
// import gif1 from "../../images/icon/original-66948a0d81d.gif";
// import gif2 from "../../images/icon/0deec720000b2066289b.gif";
// import gif3 from "../../images/icon/b10c3e43e836d32554bf.gif";


import bluetoothSpeakerCoveer from "../../images/renderings/bluetooth-speaker/1.jpg";
import poseidonCover from "../../images/renderings/poseidon/cover.jpg";
import convoyeurCover from "../../images/renderings/convoyeur/cover.jpg"
import droneCover from "../../images/renderings/Drone/cover.jpg";
import droneTwo from "../../images/renderings/Drone/1.jpeg"
import droneOne from "../../images/renderings/Drone/2.jpeg"
import droneThree from "../../images/renderings/Drone/3.jpeg"

import { Link } from "react-router-dom";



const projects = [
  {
    id:200,
    name:'Drone case study',
    img:droneOne
  },
  {
    id:201,
    name:'Drone case study',
    img:droneTwo
  },
  {
    id:199,
    name:'Drone case study',
    img:droneThree
  },
  {
    id:1,
    name : "Bluetooth speaker",
    img : bluetoothSpeakerCoveer
  },
  {
    id:2,
    name : "Poseidon",
    img : poseidonCover
  },
  {
    id:3,
    name : "Convoyeur",
    img : convoyeurCover
  },
  {
    id:4,
    name : "Drone",
    img : droneCover
  },
]

const AboutSection: React.FC = () => {
  useEffect(() => {
    const bgEl = document.querySelector<HTMLElement>(".xb-about-img-wrap");
    if (bgEl) bgEl.style.backgroundImage = `url(${aboutBg})`;
  }, []);

  return (
    <section className="about pt-140">
      <div className="container">
        <div className="sec-title about-sec-title mb-75">
          <span className="sub-title">Who We are?</span>
          <h2 className="title">
            We help grow businesses..
          </h2>
        </div>
      </div>

      {/* ✅ One single marquee with all 3 images */}
      <div className="xb-about-img-wrap bg_img wow">
        <Marquee speed={40} gradient={false} pauseOnHover={false}>
          {projects.map(({name,id,img}, idx) => (
            <div key={id} className="xb-about-img-item img-hove-effect">
              <div className="xb-img">
                <Link to="/"> {/*service-details*/}
                  <img src={img} alt={`about-${idx + 1}`} style={{width:"633px",height:'455px'}}/>
                </Link>
              </div>
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
};

export default AboutSection;
